// extracted by mini-css-extract-plugin
module.exports = {"list":"Updates_list__2GOmG","editButton":"Updates_editButton__3OA03"};